
import config from 'common-module/src/config';
export const SYNC_VERSON = '2022/02/24';
export const WS_URL = config.VUE_APP_WS_URL;
export const DB_NAME = config.VUE_APP_DB_NAME;
export const APP_VERSION = '220225';
export const SYNC_VERSION = '20220224';
const version = Number(config.VUE_APP_DB_VERSION);
export const DB_STORE_CONFIG = {
  [version]:{
    stores:{
      issue:'&id, projectId, summary, status, assignee, parentId, issueTypeId, issueTypeIdVO.code, [issueTypeIdVO.code+projectId], sprint, workflowId, updateTime',
      issueLayout: '&issueTypeId, projectId, updateTime',
      issueType: '&id, projectId, name, updateTime',
      project: '&id, projectId',
      workflow: '&id, projectId, updateTime',
      issueRelationship: '&fromIssueId, *relationIds, updateTime',
      label:'&id, labelName, name, projectId, updateTime',
      sprint:'&id, name, projectId, startDate, endDate, status, deleteFlag, updateTime',
      releaseVersion:'&id, name, description, startDate, updateTime',
      priority: '&id, name, sequence, updateTime',
      issueColumnClear: '&id, issueId, status, updateTime',
      meta: 'type, lastSyncId, updateAt',
      projectMember:'&id, projectId, userId, username, enabled, updateTime'
    }
  }
};
